import { isIstaDamageLine } from './isIstaDamageLine';

export const canEditWorkCentre = ({
  canChangeWorkCenter,
  isDeleted = false,
  mechanicalFailure,
}: {
  canChangeWorkCenter?: boolean;
  isDeleted?: boolean;
  mechanicalFailure?: string | null;
}) =>
  !!canChangeWorkCenter && !isDeleted && !isIstaDamageLine(mechanicalFailure);
